<input (keydown)="filter( term.value )" type="text" placeholder="Búsque su moneda..." class="w-mxmodal" #term>
<div class="modal-coins scroll-show">
    <a *ngFor="let coin of coinsSearch" (click)="coinSelected=coin.iso" class="cl-black">
        <p [class.bg-aux-05]="coinSelected===coin.iso">{{ coin.iso + ' (' + (coin.coin | titlecase) + ')'}}</p>
    </a>
    <p *ngIf="coinsSearch.length<=0">No hay monedas con ese nombre</p>
</div>
<button (click)="coinSel()" class="btn-red sm mt-1">Ok</button>